import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup, Input, Label, InputGroup, Alert } from 'reactstrap'
import { so3Correction } from '../../../formulas/so3Correction'

export default class SO3CorrectionForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasResult: false, hasError: false, error: 'Error in calculation' }
    }

    componentDidMount() {
        this.props.formToState({ reactorTemperature: 76, sufluricAcidCH: 98.5, sulfuricAcidD: 1815 })
    }

    calculateCorrection = (e) => {
        e.preventDefault()
        e.stopPropagation()
        try {
            const result = so3Correction(this.props.formValues)
            this.props.formToState({ result }) // Redux result
            this.setState({ hasResult: true, hasError: false })
        } catch (err) {
            this.setState({ hasError: true, hasResult: false })
        }
    }

    handleChange = (e) => {
        const target = e.target
        this.props.formToState({ [target.name]: target.value })
    }

    render() {
        return (
            <Form onSubmit={this.calculateCorrection}>
                <FormGroup>
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="reactorVolume">Reactor volume <b>(m³)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.001"  required type="number" name="reactorVolume" id="reactorVolume" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="reactorTemperature">Reactor temperature <b>(°C)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.1" value={this.props.formValues.reactorTemperature} required type="number" name="reactorTemperature" id="reactorTemperature" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="sufluricAcidCH">H2SO4 concentration <b>(%w/w)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.1" value={this.props.formValues.sufluricAcidCH} required type="number" name="sufluricAcidCH" id="sufluricAcidCH" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="sulfuricAcidD">H2SO4 density <b>(kg/m³)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.1" value={this.props.formValues.sulfuricAcidD} required type="number" name="sulfuricAcidD" id="sulfuricAcidD" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="slurryDensity">Slurry density at reactor temperature <b>(kg/m³)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.1"  required type="number" name="slurryDensity" id="slurryDensity" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="phosphoricAcidContent">P2O5 acid content <b>(%)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.1"  required type="number" name="phosphoricAcidContent" id="phosphoricAcidContent" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="phosphoricAcidDensity">Acid density at reactor temperature <b>(kg/m³)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.1" required type="number" name="phosphoricAcidDensity" id="phosphoricAcidDensity" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="sulfuricMesured">SO3 measured <b>(g/L)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.1" required type="number" name="sulfuricMesured" id="sulfuricMesured" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="sulfuricExpected">SO3 expected <b>(g/L)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.1" required type="number" name="sulfuricExpected" id="sulfuricExpected" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="duration">Duration <b>(minutes)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input  required type="number" name="duration" id="duration" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                </FormGroup>
                <Input type="submit" value="Calculate H2SO4 flow variation" className="custom-button" onClick={this.calculateCorrection} />
                <br />
                {/** Résultat */}
                {this.state.hasResult ?
                    <div className="formula-result text-center">
                        {`H2SO4 flow variation :  ${this.props.formValues.result.flowVariation} m³/h during ${this.props.formValues.result.duration} minutes`}
                    </div>
                    : null}
                {/** Erreur */}
                {this.state.hasError ?
                    <div className="text-center">
                        <Alert color="danger">
                            {this.state.error}
                        </Alert>
                    </div>
                    : null}
            </Form>
        )
    }
}
SO3CorrectionForm.propTypes = {
    formToState: PropTypes.func,
    formValues: PropTypes.shape({

    })
}